export default function countryAndAssetTypeColumnsSpecification(config) {
    const { data = [] } = config;

    if (!data) return null;

    let result = {};
    let tableData = [];

    data.map(countryAndAssetTypeOption => {
        const assetTypes = Object.keys(countryAndAssetTypeOption);
        assetTypes.map(assetType => {
            let row = [];
            const asset = countryAndAssetTypeOption[assetType] || {};
            const rowId = assetType + "|" + asset.countryCode;

            config.columns.forEach(column => {
                const columnId = column.id;
                const displayAsIs = column.data.displayInBodyAsIs;
                const columnDataType = column.data.displayInBodyAs;
                const highlightColumn = column.data.highlightBodyText;

                let columnValue = null;

                if (columnDataType === "string") {
                    if (columnId === "countryCode") {
                        columnValue = asset.countryCode || "";
                    }
                    else if (columnId === "assetType") {
                        columnValue = assetType || "";
                    }
                    else if (columnId === "hardwareDownlift") {
                        columnValue = asset.hwDownlift !== null || asset.hwDownlift !== undefined ? asset?.hwDownlift?.toFixed(2) : "0.00";
                    }
                    else if (columnId === "logisticUplift") {
                        columnValue = asset.logisticUplift !== null || asset.logisticUplift !== undefined ? asset?.logisticUplift?.toFixed(2) : "0.00";
                    }
                    else if (columnId === "processingUplift") {
                        columnValue = asset.processingUplift !== null || asset.processingUplift !== undefined ? asset?.processingUplift?.toFixed(2) : "0.00";
                    }
                }

                row.push({
                    [columnId]: {
                        id: rowId,
                        columnId: columnId,
                        type: columnDataType,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs,
                        highlightColumn: highlightColumn
                    }
                });
            });

            tableData.push({
                id: rowId,
                data: row
            });
        });
    });

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
